import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from 'cn';

const textareaVariants = cva(
  'flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent py-2 transition-colors outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-2 aria-invalid:ring-destructive/30 dark:bg-input/30 dark:disabled:bg-input/80',
  {
    variants: {
      size: {
        default: 'px-2.5 text-base md:text-sm',
        // Design-system lg: 16px text, matches Input lg.
        lg: 'min-h-24 px-3 text-base',
      },
      strong: {
        false: 'border-input',
        true: 'border-input-strong',
      },
    },
    defaultVariants: { size: 'default', strong: false },
  },
);

function Textarea({
  className,
  size,
  strong,
  ...props
}: React.ComponentProps<'textarea'> & VariantProps<typeof textareaVariants>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(textareaVariants({ size, strong }), className)}
      {...props}
    />
  );
}

export { Textarea, textareaVariants };
